import * as jose from "jose";
const REACT_APP_ISSUER = process.env.REACT_APP_ISSUER;
const REACT_APP_AUDIENCE = process.env.REACT_APP_AUDIENCE;
const REACT_APP_SECURITYKEY = process.env.REACT_APP_SECURITYKEY;

export default async function genrateJWTToken(paylod) {
  const secret = new TextEncoder().encode(REACT_APP_SECURITYKEY);
  const alg = "HS256";
  try {
    const jwt = await new jose.SignJWT(paylod)
      .setProtectedHeader({ alg })
      .setIssuedAt()
      .setIssuer(REACT_APP_ISSUER)
      .setAudience(REACT_APP_AUDIENCE)
      .setExpirationTime("2h")
      .sign(secret);
    return jwt;
  } catch (error) {
    console.log(error);
  }
}
